class DescricaoID {

    id: string | null;
    descricao: string | null;

    constructor(id: string, descricao: string) {
        this.id = id;
        this.descricao = descricao;
    }
}

export default DescricaoID;
